import { render } from "./businessCard.vue?vue&type=template&id=01cf679c"
import script from "./businessCard.vue?vue&type=script&lang=js"
export * from "./businessCard.vue?vue&type=script&lang=js"

import "./businessCard.vue?vue&type=style&index=0&id=01cf679c&lang=scss"

import exportComponent from "D:\\AllProject\\h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__